import { render, staticRenderFns } from "./PageContent.vue?vue&type=template&id=a0347772&scoped=true&"
import script from "./PageContent.vue?vue&type=script&lang=js&"
export * from "./PageContent.vue?vue&type=script&lang=js&"
import style0 from "./PageContent.vue?vue&type=style&index=0&id=a0347772&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0347772",
  null
  
)

export default component.exports